import React from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import StepHistory from "./Studio/Edit/StepHistory";
import { useFetchFailureAnalysis } from "../useQuery";

const FailureAnalysisPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tsrid = searchParams.get("tsrid");

  const { data, isLoading, isError, error } = useFetchFailureAnalysis(tsrid);

  const mockEditItem = {
    Test_Case_Results_Id: tsrid,
  };

  if (isLoading) return <Box p={3}>Loading...</Box>;
  if (isError) return <Box p={3}>Error: {error.message}</Box>;

  return (
    <Box className="bg-gray-100 min-h-screen px-4 md:px-6">
      <Box className="max-w-8xl mx-auto">
        {/* Header with test details */}
        <Box className="bg-gray-800 text-white py-3 px-4 rounded-md shadow-md mb-4">
          <h1 className="text-lg font-semibold mb-2">Failure Analysis</h1>
          <Box className="flex flex-wrap">
            <Box className="w-1/2 text-left mb-1">
              <span className="text-gray-300 text-sm">Step Number:</span>{" "}
              <span className="font-medium">{data.details?.step_number}</span>
            </Box>
            <Box className="w-1/2 text-left mb-1">
              <span className="text-gray-300 text-sm">Test Case Id:</span>{" "}
              <span className="font-medium">{data.details?.test_case_id}</span>
            </Box>
            <Box className="w-1/2 text-left mb-1">
              <span className="text-gray-300 text-sm">Test Case Name:</span>{" "}
              <span className="font-medium">{data.details?.test_case_name}</span>
            </Box>
            <Box className="w-1/2 text-left mb-1">
              <span className="text-gray-300 text-sm">Step Id:</span>{" "}
              <span className="font-medium">{data.details?.test_step_id}</span>
            </Box>
          </Box>
        </Box>

        {/* StepHistory component */}
        <StepHistory currentEditItem={mockEditItem} fromExcReports={true} />
      </Box>
    </Box>
  );
};

export default FailureAnalysisPage;
